import { DrawIoEmbed } from "react-drawio";
import { useEffect, useRef, useState } from "react";
import NavBar from "./NavBar";
import ButtonComponent from "./ButtonComponent";
import useWebsocketHook from "../hooks/post-websocket-data";

function Diagram() {
  const drawIoRef = useRef(null);
  const [imgData, setImgData] = useState(null);
  const [drawioInstance, setDrawioInstance] = useState(null);
  const [inputData, setInputData] = useState({
    topic: "",
  });
  const [ws, setWs] = useState(null);
  const { stringWords, setstringWords } = useWebsocketHook();
  const [loader, setloader] = useState(false);
  const [stringOutput, setstringOutput] = useState("");
  const [closeOpen, setcloseOpen] = useState(false);
  const [finalString, setfinalString] = useState("");
  const handleLoad = () => {
    if (drawIoRef.current) {
      setDrawioInstance(drawIoRef.current.contentWindow.drawio);
    }
  };
  console.log("drawioInstance", drawioInstance, imgData);

  const handleExport = () => {
    if (drawIoRef.current) {
      const xml = drawIoRef.current.exportDiagram({
        format: "xml",
      });
      console.log("Exported XML:", xml);
    }
  };

  //   const sampleXml = `<mxfile host="app.diagrams.net">
  //   <diagram name="Page-1">
  //     <mxGraphModel dx="1164" dy="1038" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" pageWidth="827" pageHeight="1169" math="0" shadow="0">
  //       <root>
  //         <mxCell id="0" />
  //         <mxCell id="1" parent="0" />
  //         <mxCell id="2" value="Rectangle" style="rounded=0;whiteSpace=wrap;html=1;" vertex="1" parent="1">
  //           <mxGeometry x="120" y="180" width="160" height="80" as="geometry" />
  //         </mxCell>
  //         <mxCell id="3" value="Ellipse" style="ellipse;whiteSpace=wrap;html=1;" vertex="1" parent="1">
  //           <mxGeometry x="380" y="180" width="160" height="80" as="geometry" />
  //         </mxCell>
  //         <mxCell id="4" edge="1" source="2" target="3" parent="1">
  //           <mxGeometry relative="1" as="geometry" />
  //         </mxCell>
  //       </root>
  //     </mxGraphModel>
  //   </diagram>
  // </mxfile>
  // `;

  const sampleXml2 = `data:image/svg+xml;base64,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`;
  const extractMxfile = (xmlString) => {
    const regex = /<mxfile[^>]*>([\s\S]*?)<\/mxfile>/;
    const match = xmlString.match(regex);
    return match ? match[0] : null;
  };
  // const postWebsocketDetails = (data_incoming, api) => {
  //   console.log(data_incoming, "data_incoming api");
  //   setloader(true);
  //   setstringOutput("");
  //   setstringWords("");
  //   // return;
  //   // setcloseOpen(true);
  //   if (ws) {
  //     ws?.close();
  //     setWs(null);
  //   }
  //   const newWs = new WebSocket(`${process.env.REACT_APP_BASE_URL}/${api}`);

  //   setWs(newWs);

  //   let string = "";
  //   newWs.onopen = function open() {
  //     let new_data = {
  //       ...data_incoming,
  //       token: localStorage.getItem("login_token"),
  //     };
  //     new_data["model"] = "model_6";
  //     const dataToSend = JSON.stringify(new_data);
  //     newWs.send(dataToSend);
  //   };
  //   setstringWords("");

  //   newWs.onmessage = function incoming(data) {
  //     console.log("received", data.data);

  //     const word = data.data;
  //     if (word?.charAt(0) == "{" && word.charAt(word.length - 1) == "}") {
  //       setstringOutput(word);
  //       setloader(false);
  //     } else {
  //       string += word;
  //       setstringWords(string);
  //     }
  //   };

  //   newWs.onclose = () => {
  //     setloader(false);
  //     console.log("WebSocket connection closed.");
  //   };

  //   newWs.onerror = (error) => {
  //     setloader(false);
  //     console.error("WebSocket error:", error);
  //   };
  // };
  // const postWebsocketDetails = (data_incoming, api) => {
  //   console.log(data_incoming, "data_incoming api");
  //   setloader(true);
  //   setstringOutput("");
  //   setstringWords("");

  //   if (ws) {
  //     ws.close();
  //     setWs(null);
  //   }
  //   const newWs = new WebSocket(`${process.env.REACT_APP_BASE_URL}/${api}`);
  //   setWs(newWs);

  //   let buffer = "";
  //   let mxfile = `<mxfile host="app.diagrams.net">`; // Example of the starting mxfile tag
  //   let diagram = "";
  //   let mxGraphModel = "";
  //   let root = "";
  //   let finalXML = "";

  //   newWs.onopen = function open() {
  //     let new_data = {
  //       ...data_incoming,
  //       token: localStorage.getItem("login_token"),
  //     };
  //     new_data["model"] = "model_6";
  //     const dataToSend = JSON.stringify(new_data);
  //     newWs.send(dataToSend);
  //   };

  //   newWs.onmessage = function incoming(data) {
  //     console.log("received", data.data);

  //     const word = data.data;
  //     buffer += word;

  //     // Regular expression to match specific parts
  //     const mxCellPattern = /<mxCell[^>]*>[\s\S]*?<\/mxCell>/g;
  //     let match;

  //     while ((match = mxCellPattern.exec(buffer)) !== null) {
  //       const completeCell = match[0];

  //       // Attach structure around the completeCell
  //       if (!diagram) {
  //         diagram = `<diagram name="Page-1">`;
  //       }
  //       if (!mxGraphModel) {
  //         mxGraphModel = `<mxGraphModel dx="1422" dy="695">`;
  //       }
  //       if (!root) {
  //         root = `<root>`;
  //       }

  //       // Construct the complete XML structure with current cell
  //       const currentBlock = `${mxfile}${diagram}${mxGraphModel}${root}${completeCell}</root></mxGraphModel></diagram></mxfile>`;

  //       // Update the final XML
  //       finalXML = currentBlock;
  //       setstringWords(finalXML);

  //       // Remove the processed block from the buffer
  //       buffer = buffer.slice(match.index + completeCell.length);
  //     }

  //     if (word.charAt(0) === "{" && word.charAt(word.length - 1) === "}") {
  //       setloader(false);
  //     }
  //   };

  //   newWs.onclose = () => {
  //     setloader(false);
  //     console.log("WebSocket connection closed.");
  //   };

  //   newWs.onerror = (error) => {
  //     setloader(false);
  //     console.error("WebSocket error:", error);
  //   };
  // };
  const postWebsocketDetails = (data_incoming, api) => {
    console.log(data_incoming, "data_incoming api");
    setloader(true);
    setstringOutput("");
    setstringWords("");
    setfinalString("");
  
    if (ws) {
      ws.close();
      setWs(null);
    }
  
    const newWs = new WebSocket(`${process.env.REACT_APP_BASE_URL}/${api}`);
    setWs(newWs);
  
    let buffer = "";
    let finalXml = ""; // To hold the final XML structure
    let string="";
    let isHeaderAdded = false;
  
    // Regular expressions to detect the start of key elements
    const mxfilePattern = /<mxfile[^>]*>/;
    const diagramPattern = /<diagram[^>]*>/;
    const mxGraphModelPattern = /<mxGraphModel[^>]*>/;
    const rootPattern = /<root[^>]*>/;
  
    newWs.onopen = function open() {
      let new_data = {
        ...data_incoming,
        token: localStorage.getItem("login_token"),
      };
      new_data["model"] = "model_6";
      const dataToSend = JSON.stringify(new_data);
      newWs.send(dataToSend);
    };
  
    newWs.onmessage = function incoming(data) {
      console.log("received", data.data);
  
      const word = data.data;
      buffer += word;
      string+=word;
  
      // Check if headers have been added, if not, check and add them
      if (!isHeaderAdded) {
        if (mxfilePattern.test(buffer)) {
          finalXml += buffer.match(mxfilePattern)[0];
          buffer = buffer.replace(mxfilePattern, ""); // Remove matched tag from buffer
        }
        if (diagramPattern.test(buffer)) {
          finalXml += buffer.match(diagramPattern)[0];
          buffer = buffer.replace(diagramPattern, ""); 
        }
        if (mxGraphModelPattern.test(buffer)) {
          finalXml += buffer.match(mxGraphModelPattern)[0];
          buffer = buffer.replace(mxGraphModelPattern, "");
        }
        if (rootPattern.test(buffer)) {
          finalXml += buffer.match(rootPattern)[0];
          buffer = buffer.replace(rootPattern, "");
          isHeaderAdded = true;
        }
      }
  
      // Regular expression to match completed mxCell blocks
      const mxCellPattern = /<mxCell[^>]*>[\s\S]*?<\/mxCell>/g;
      let match;
  
      while ((match = mxCellPattern.exec(buffer)) !== null) {
        const completeCell = match[0];
        
        // Concatenate the completeCell to the finalXml
        finalXml += completeCell;
        let totalXml=finalXml+`</root></mxGraphModel></diagram></mxfile>`;
  
        // Update the state with the latest structure
        setstringWords(totalXml);
        
        // Remove the processed block from the buffer
        buffer = buffer.slice(match.index + completeCell.length);
      }
  
      if (word.charAt(0) === "{" && word.charAt(word.length - 1) === "}") {
        // Add the closing tags once all data is received
        // finalXml += `</root></mxGraphModel></diagram></mxfile>`;
        // setstringWords(finalXml);
        setfinalString(string);
        setloader(false);
      }
    };
  
    newWs.onclose = () => {
      setloader(false);
      console.log("WebSocket connection closed.");
    };
  
    newWs.onerror = (error) => {
      setloader(false);
      console.error("WebSocket error:", error);
    };
  };
  const closeFunction = () => {
    setcloseOpen(false);
    setloader(false);
    // setstringOutput("");
    // setstringWords("");
    ws?.close();
  }
  
  

  console.log("stringOutput", stringOutput);
  console.log("stringWords", stringWords);
  console.log("finalString", finalString);

  return (
    <div className="wrapper">
      <NavBar />
      <form
        onSubmit={(e) => {
          e.preventDefault();

          postWebsocketDetails(
            {
              query: inputData.topic,
            },
            "drawio"
          );
        }}
      >
        <div className="pb-3">
          <label class="block mb-2 font-semibold text-[18px]" htmlFor="topic">
            Topic
          </label>
          <textarea
            className="w-full rounded-[20px] font-[400] min-h-[80px] text-[16px] border border-[#E9EBF0] bg-[#FAFBFC]"
            id="topic"
            name="msgarea"
            placeholder="Enter Topic"
            onChange={(e) =>
              setInputData({ ...inputData, topic: e.target.value })
            }
            value={inputData.topic}
            required
          ></textarea>
        </div>
        <ButtonComponent
          loader={loader}
          mainTitle={"Diagram"}
          closeFunction={closeFunction}
        />
      </form>
      {/* {closeOpen && ( */}
      <div style={{ height: "80vh" }}>
        <DrawIoEmbed
          ref={drawIoRef}
          urlParameters={{
            ui: "simple",
            spin: true,
            libraries: true,
            saveAndExit: false,
            noExitBtn: true,
          }}
          xml={extractMxfile(stringWords)}
          // xml={`
          // <mxfile host="app.diagrams.net">
          //     <diagram>
          //       <mxGraphModel dx="1132" dy="629" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="0" page="1" pageScale="1" pageWidth="827" pageHeight="1169" background="#ffffff" math="0" shadow="0">
          //         <root>

          //           <mxCell id="0"/>
          //           <mxCell id="1" parent="0"/>
          //           <mxCell id="2" value="Requirement Gathering" style="shape=datastore;whiteSpace=wrap;html=1;rounded=0;strokeColor=#000000;fillColor=#97c1f7;" vertex="1" connectable="0" parent="1">
          //             <mxGeometry x="260" y="180" width="120" height="60" as="geometry"/>
          //           </mxCell>
          //           <mxCell id="3" value="Design" style="shape=datastore;whiteSpace=wrap;html=1;rounded=0;strokeColor=#000000;fillColor=#97c1f7;" vertex="1" connectable="0" parent="1">
          //             <mxGeometry x="260" y="280" width="120" height="60" as="geometry"/>
          //           </mxCell>
          //           <mxCell id="4" value="Development" style="shape=datastore;whiteSpace=wrap;html=1;rounded=0;strokeColor=#000000;fillColor=#97c1f7;" vertex="1" connectable="0" parent="1">
          //             <mxGeometry x="260" y="380" width="120" height="60" as="geometry"/>
          //           </mxCell>
          //           <mxCell id="5" value="Testing" style="shape=datastore;whiteSpace=wrap;html=1;rounded=0;strokeColor=#000000;fillColor=#97c1f7;" vertex="1" connectable="0" parent="1">
          //             <mxGeometry x="260" y="480" width="120" height="60" as="geometry"/>
          //           </mxCell>
          //           <mxCell id="6" value="Deployment" style="shape=datastore;whiteSpace=wrap;html=1;rounded=0;strokeColor=#000000;fillColor=#97c1f7;" vertex="1" connectable="0" parent="1">
          //             <mxGeometry x="260" y="580" width="120" height="60" as="geometry"/>
          //           </mxCell>
          //           <mxCell id="7" value="" style="edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;" edge="1" parent="1" source="2" target="3">
          //             <mxGeometry relative="1" as="geometry">
          //               <mxPoint x="260" y="240" as="targetPoint"/>
          //             </mxGeometry>
          //           </mxCell>
          //           <mxCell id="8" value="" style="edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;" edge="1" parent="1" source="3" target="4">
          //             <mxGeometry relative="1" as="geometry">
          //               <mxPoint x="260" y="340" as="targetPoint"/>
          //             </mxGeometry>
          //           </mxCell>
          //           <mxCell id="9" value="" style="edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;" edge="1" parent="1" source="4" target="5">
          //             <mxGeometry relative="1" as="geometry">
          //               <mxPoint x="260" y="440" as="targetPoint"/>
          //             </mxGeometry>
          //           </mxCell>
          //           <mxCell id="10" value="" style="edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;" edge="1" parent="1" source="5" target="6">
          //             <mxGeometry relative="1" as="geometry">
          //               <mxPoint x="260" y="540" as="targetPoint"/>
          //             </mxGeometry>
          //           </mxCell>
          //         </root>
          //       </mxGraphModel>
          //     </diagram>
          //   </mxfile>`}
          //             xml={`
          //             <mxfile host="app.diagrams.net">
          //   <diagram id="Diagram1" name="Page-1">
          //     <mxGraphModel dx="2000" dy="2000" grid="1" gridSize="10" guides="1" tooltips="1" connect="1" arrows="1" fold="1" page="1" pageScale="1" pageWidth="827" pageHeight="1169" math="0" shadow="0">
          //       <root>
          //         <!-- Shapes -->
          //         <mxCell id="0"/>
          //         <mxCell id="1" parent="0"/>

          //         <!-- Start Oval -->
          //         <mxCell id="2" value="Start" style="shape=ellipse;whiteSpace=wrap;html=1;aspect=fixed;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="50" width="80" height="40" as="geometry"/>
          //         </mxCell>

          //         <!-- Collect Data -->
          //         <mxCell id="3" value="Collect Data" style="shape=rectangle;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="150" width="100" height="60" as="geometry"/>
          //         </mxCell>

          //         <!-- Preprocess Data -->
          //         <mxCell id="4" value="Preprocess Data" style="shape=rectangle;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="260" width="100" height="60" as="geometry"/>
          //         </mxCell>

          //         <!-- Feature Engineering -->
          //         <mxCell id="5" value="Feature Engineering" style="shape=rectangle;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="370" width="120" height="60" as="geometry"/>
          //         </mxCell>

          //         <!-- Select Model -->
          //         <mxCell id="6" value="Select Model" style="shape=rhombus;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="480" width="100" height="80" as="geometry"/>
          //         </mxCell>

          //         <!-- Train Model -->
          //         <mxCell id="7" value="Train Model" style="shape=rectangle;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="610" width="100" height="60" as="geometry"/>
          //         </mxCell>

          //         <!-- Evaluate Model -->
          //         <mxCell id="8" value="Evaluate Model" style="shape=rectangle;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="720" width="100" height="60" as="geometry"/>
          //         </mxCell>

          //         <!-- Tune Hyperparameters? -->
          //         <mxCell id="9" value="Tune Hyperparameters?" style="shape=rhombus;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="830" width="120" height="80" as="geometry"/>
          //         </mxCell>

          //         <!-- Deploy Model -->
          //         <mxCell id="10" value="Deploy Model" style="shape=rectangle;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="960" width="100" height="60" as="geometry"/>
          //         </mxCell>

          //         <!-- Monitor Model -->
          //         <mxCell id="11" value="Monitor Model" style="shape=rectangle;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="1070" width="100" height="60" as="geometry"/>
          //         </mxCell>

          //         <!-- Maintain Model -->
          //         <mxCell id="12" value="Maintain Model" style="shape=rectangle;whiteSpace=wrap;html=1;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="1180" width="110" height="60" as="geometry"/>
          //         </mxCell>

          //         <!-- End Oval -->
          //         <mxCell id="13" value="End" style="shape=ellipse;whiteSpace=wrap;html=1;aspect=fixed;" vertex="1" parent="1">
          //           <mxGeometry x="100" y="1290" width="80" height="40" as="geometry"/>
          //         </mxCell>

          //         <!-- Connectors -->
          //         <mxCell id="14" value="" style="edgeStyle=orthogonalEdgeStyle;rounded=0;orthogonalLoop=1;jettySize=auto;html=1;exitX=0.5;exitY=1;exitDx=0;exitDy=0;" edge="1" parent="1" source="2" target="3">
          //           <mxGeometry relative="1" as="geometry"/>
          //         </mxCell>
          //         <mxCell id="15" value="" style="..." edge="1" parent="1" source="3" target="4"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="16" value="" style="..." edge="1" parent="1" source="4" target="5"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="17" value="" style="..." edge="1" parent="1" source="5" target="6"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="18" value="" style="..." edge="1" parent="1" source="6" target="7"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="19" value="" style="..." edge="1" parent="1" source="7" target="8"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="20" value="" style="..." edge="1" parent="1" source="8" target="9"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="21" value="" style="..." edge="1" parent="1" source="9" target="10"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="22" value="" style="..." edge="1" parent="1" source="10" target="11"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="23" value="" style="..." edge="1" parent="1" source="11" target="12"><mxGeometry relative="1" as="geometry"/></mxCell>
          //         <mxCell id="24" value="" style="..." edge="1" parent="1" source="12" target="13"><mxGeometry relative="1" as="geometry"/></mxCell>

          //         <!-- Loopback to Train Model from Tune Hyperparameters -->
          //         <mxCell id="25" value="" style="edgeStyle=orthogonalEdgeStyle;curved=1;orthogonalLoop=1;jettySize=auto;html=1;entryX=0.5;entryY=0;entryDx=0;entryDy=0;" edge="1" parent="1" source="9" target="7">
          //           <mxGeometry relative="1" as="geometry"/>
          //         </mxCell>
          //       </root>
          //     </mxGraphModel>
          //   </diagram>
          // </mxfile>
          //             `}
          onLoad={handleLoad}
          onExport={(data) => setImgData(data.data)}
          onSave={(data) => console.log("saved", data.xml)}
        />
      </div>
      {/* )} */}
      {/* <button onClick={handleExport}>Export Diagram</button> */}
    </div>
  );
}

export default Diagram;
